import {
  ADD_BOARD_MEETING_MINUTES,
  DELETE_BOARD_MEETING_MINUTES,
  EDIT_BOARD_MEETING_MINUTES,
  GET_MEETING_MINUTES,
  GET_MEETING_MINUTES_CATEGORIES,
} from "./MeetingMinutesType";

export const MeetingMinutesReducer = (
  state = {
    Categories: [],
    MeetingMinutes: [],
    TasksMinMeets: [],
  },
  action
) => {
  switch (action.type) {
    case GET_MEETING_MINUTES_CATEGORIES: {
      return {
        ...state,
        Categories: action.Payload,
      };
    }
    case GET_MEETING_MINUTES: {
      return {
        ...state,
        MeetingMinutes: action.Payload.BoardMeetingMinutes,
        TasksMinMeets: action.Payload.TasksMeetingMinutes,
      };
    }
    case ADD_BOARD_MEETING_MINUTES: {
      return {
        ...state,
        MeetingMinutes: [...state.MeetingMinutes, action.Payload],
      };
    }
    case EDIT_BOARD_MEETING_MINUTES: {
      const MeetingMinutes1 = state.MeetingMinutes;
      const Find1 = MeetingMinutes1.find(
        (item) => item._id === action.Payload._id
      );
      const IndexOf1 = MeetingMinutes1.indexOf(Find1);
      MeetingMinutes1[IndexOf1] = action.Payload;
      return {
        ...state,
        MeetingMinutes: [...MeetingMinutes1],
      };
    }
    case DELETE_BOARD_MEETING_MINUTES: {
      const MeetingMinutes2 = state.MeetingMinutes;
      const Filter2 = MeetingMinutes2.filter(
        (item) => item._id !== action.Payload
      );
      return {
        ...state,
        MeetingMinutes: [...Filter2],
      };
    }
    default: {
      return state;
    }
  }
};
